const STRIPS = 10;

export default function EntranceBlinds() {
  return (
    <div className="wp-entrance absolute inset-0 z-50 flex flex-col" aria-hidden="true">
      {Array.from({ length: STRIPS }).map((_, i) => (
        <div key={i} className="wp-strip flex-1 -mb-px" />
      ))}
    </div>
  );
}